<template lang="pug">
#modal-change-password
    //- Button
    button.btn.btn-sm.btn-secondary(@click="showModal = true", :disabled="user.role === 'owner'")
        font-awesome-icon.mr-2(icon="key")
        | Passwort zurücksetzen

    //- Modal
    .modal-backdrop.fade.show(v-if="showModal")
    .modal(:class="{ 'd-block': showModal }")
        .modal-dialog.modal-dialog-scrollable.modal-md: .modal-content
            header.modal-header
                h5.modal-title Passwort zurücksetzen
                button.close(type="button", @click="showModal = false") &times;

            .modal-body
                .form-group
                    label Neues Passwort
                    .input-group(:class="{ 'is-invalid': $v.password.$dirty && $v.password.$error }")
                        input.form-control(:type="showPassword ? 'text' : 'password'", v-model="password", required)
                        .input-group-append
                            button.btn.btn-light(type="button", @click="showPassword = !showPassword")
                                font-awesome-icon(:icon="showPassword ? 'eye' : 'eye-slash'")
                    .invalid-feedback Bitte geben Sie ein mindestens 6-stelliges Passwort an
                .form-group
                    label Passwort wiederholen
                    input.form-control(
                        type="password",
                        v-model="password2",
                        :class="{ 'is-invalid': $v.password2.$dirty && $v.password2.$error }",
                        required
                    )
                    .invalid-feedback Bitte wiederholen Sie das Passwort zur Bestätigung

            footer.modal-footer
                button.btn.btn-secondary(type="button", @click="showModal = false") Abbrechen
                button.btn.btn-primary(type="button", @click="changeAndClose") Neues Passwort speichern
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faKey } from '@fortawesome/free-solid-svg-icons'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { userService } from '@/services'

library.add(faKey)

export default {
    props: {
        user: {
            type: Object,
            default () {},
            validator (value) {
                return !!value.id
            }
        }
    },
    data: function () {
        return {
            password: '',
            password2: '',
            showModal: false,
            showPassword: false
        }
    },
    validations: {
        password: {
            required,
            minLength: minLength(6)
        },
        password2: {
            required,
            sameAsPassword: sameAs('password')
        }
    },
    methods: {
        async changeAndClose () {
            // validate password
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }

            try {
                await userService.update(this.user.id, { password: this.password })
                this.$store.dispatch('alert/success', 'Neues Passwort für ' + this.user.username + ' gespeichert.')
            } catch (error) {
                this.$store.dispatch('alert/error', 'Passwort konnten nicht gespeichert werden (' + error.message + ')')
            }

            this.showModal = false
        }
    }
}
</script>
